import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { TRF_SESSION_BASE_PATH } from '../../../../../../../../../features/trf/session/trf-session-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-session/_trf-session')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'trf-session-list',
        label: 'Trades',
        to: TRF_SESSION_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
